import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { FuseConfigService } from '@fuse/services/config.service';
import { navigation } from 'app/navigation/navigation';
import { AuthenticationService } from 'app/services';

@Component({
    selector: 'vertical-layout-2',
    templateUrl: './layout-2.component.html',
    styleUrls: ['./layout-2.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class VerticalLayout2Component implements OnInit, OnDestroy {
    fuseConfig: any;
    navigation: any;
    currentUser: any;

    // Private
    private _unsubscribeAll: Subject<void> = new Subject<void>();

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     */
    constructor(
        private _authenticationService: AuthenticationService,
        private _fuseConfigService: FuseConfigService
    ) {
        this.currentUser = this._authenticationService.currentUserValue;
        // Set the defaults
        this.navigation = navigation;
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        this._authenticationService.currentUser.subscribe(() => {
            this.currentUser = this._authenticationService.currentUserValue;
        });
        // Subscribe to config changes
        this._fuseConfigService.config
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((config) => {
                this.fuseConfig = config;
            });
    }

    /**
     * On destroy
     */
    ngOnDestroy(): void {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
